import React, { useEffect, useState, useRef } from 'react'
import './MenuLang.scss'
import { useBase } from '../../../context/BaseContext'
import { FormattedMessage } from 'react-intl'
import { useAppDispatch } from '../../../hooks/store'
import { updateLanguage } from '../../../store/features/i18n/i18n.slice'
import CheckIcon from '@mui/icons-material/Check'
import userStorage from '../../../storage/user.storage'
import { IonButton } from '@ionic/react'
import { Button } from '../../components'
import appConfig from '../../../storage/config.storage'
import { appService } from '../../../services/settings.service'
import { gameServices } from '../../../services/game.service'
import { validLocale, validLocalesArray } from '../../../locale'

interface Props {}

const LangModal: React.FC<Props> = () => {
    const dispatch = useAppDispatch()
    const { initFromStorage, setLang, lang } = useBase()
    const [currentLang, setCurrentLang] = useState<validLocale>(lang)
    const { showLangModal, setShowLangModal } = useBase()
    const onUpdateLanguage = (language: string) => dispatch(updateLanguage(language))

    useEffect(() => {
        const cLang = lang
        if (cLang) {
            setCurrentLang(cLang)
        }
    }, [showLangModal])

    const validateLang = async () => {
        userStorage.setLang(currentLang)
        setLang(currentLang)
        onUpdateLanguage(currentLang)
        setShowLangModal(false)
        const config = await appConfig.getEvent()
        const adsConfig = await appConfig.getAdsConfig()
        const site = await appConfig.getPlace()
        const slug = site.slug
        if (config.slug) {
            const settings = await appService.getSettings(slug, adsConfig.areaId)
            const games = await gameServices.getSettings(slug)
            appConfig.setGames(games)
            appConfig.setEvent(settings.event)
            appConfig.setPlace(settings)
        }
    }

    const closeModal = () => {
        setShowLangModal(false)
    }

    return (
        <>
            {showLangModal ? (
                <div className='overlay'>
                    <div className='modal-lang'>
                        <h1 className='title'>
                            <FormattedMessage id={'LANG_MODAL.TITLE'} />
                        </h1>
                        <div className='lang-list'>
                            <ul className='list'>
                                <li className={'lang ' + (currentLang.includes('fr') ? 'active' : '')} onClick={() => setCurrentLang('fr')}>
                                    <FormattedMessage id={'LANG_MODAL.FRENCH'} />
                                    <div className='circle'>
                                        <CheckIcon />
                                    </div>
                                </li>
                                <li
                                    className={'lang ' + (!currentLang.includes('fr') ? 'active' : '')}
                                    onClick={() => setCurrentLang('en')}
                                >
                                    <FormattedMessage id={'LANG_MODAL.ENGLISH'} />
                                    <div className='circle'>
                                        <CheckIcon />
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className='modal-buttons'>
                            <Button className='button annulation' color='transparent' id='LANG_MODAL.MODAL_BUTTON_1' onClick={closeModal} />
                            <Button className='button' color='#DA261B' id='LANG_MODAL.MODAL_BUTTON_2' onClick={validateLang} />
                        </div>
                    </div>
                </div>
            ) : (
                false
            )}
        </>
    )
}

export default LangModal
